import {createContext} from "react";
import {ProjectFilter} from "./State";

export const ProjectFilterContext = createContext({
  conditions: [] as ProjectFilter,
  setConditions: (conditions: ProjectFilter) => {},
});
